import { useEffect } from "react";
import { track } from "../lib/tracking";

// Fires scroll-depth (50%, 90%) and time-on-page events once per page load.
export default function useEngagementTracking() {
  useEffect(() => {
    const fired = new Set();
    const onScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      const pct = (window.scrollY / scrollable) * 100;
      if (pct >= 50 && !fired.has(50)) { fired.add(50); track.scrollDepth(50); }
      if (pct >= 90 && !fired.has(90)) { fired.add(90); track.scrollDepth(90); }
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    const start = Date.now();
    const marks = [15, 30, 60, 120];
    const timers = marks.map((s) =>
      setTimeout(() => track.timeOnPage(s), s * 1000)
    );
    const onLeave = () => {
      const secs = Math.round((Date.now() - start) / 1000);
      track.timeOnPage(secs);
    };
    window.addEventListener("beforeunload", onLeave);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("beforeunload", onLeave);
      timers.forEach(clearTimeout);
    };
  }, []);
}
